module.exports = __webpack_public_path__ + "static/media/cpf-person.cb9828a4.png";